// import apiClient from "../utils/Http";
// // export const getCourseSection=(id)=>apiClient.get(`/api/section/${id}`);
// // export const getCourseSections=(id)=>apiClient.get(`/api/section/?course=${id}`);
// // export const updteCourseSection=(id,data)=>apiClient.put(`/api/section/${id}`,data);
// // export const deleteCourseSection=(id)=>apiClient.delete(`/api/section/${id}`);

// export const getAllenrollements = () => apiClient.get('/api/enrollment/');
// export const getMyEnrollments = () => apiClient.get('/api/my-enrollments/');
// export const EnrollToCourse = (courseId, enrollmentData) => 
//   apiClient.post(`/api/enroll/${courseId}/`, enrollmentData);
// export const checkEnrollment = (courseId) => apiClient.get(`/api/check-enrollment/${courseId}/`);
// export const getEnrollmentDetails = (enrollmentId) => apiClient.get(`/api/enrollment/${enrollmentId}/`);
// export const updateEnrollment = (enrollmentId, data) => apiClient.patch(`/api/enrollment/${enrollmentId}/`, data);
// export const cancelEnrollment = (enrollmentId) => 
//   apiClient.post(`/api/enrollment/${enrollmentId}/cancel/`, {});

// // Get enrolled courses for CURRENT user
// // export const getMyEnrolledCourses = () => apiClient.get('/api/user/enrolled-courses/');
// export const getMyEnrolledCourses = (params = {}) =>
//   apiClient.get('/api/user/enrolled-courses/', { params });
// // Get enrolled courses for specific user
// export const getUserEnrolledCourses = (userId) => 
//   apiClient.get(`/api/enrollments/user/${userId}/courses/`);

// // Get courses not enrolled by specific user
// export const getUserNotEnrolledCourses = (userId, filters = {}) => {
//   const params = new URLSearchParams();
  
//   if (filters.category_slug) params.append('category_slug', filters.category_slug);
//   if (filters.level) params.append('level', filters.level);
  
//   const queryString = params.toString();
//   const url = `/api/courses/not-enrolled/user/${userId}/${queryString ? `?${queryString}` : ''}`;
  
//   return apiClient.get(url);
// };

import apiClient from "../utils/Http";

// ==================== ENROLLMENT (internal / dashboard — pk) ====================
export const getAllenrollements = () => apiClient.get('/api/enrollment/');
export const getMyEnrollments = () => apiClient.get('/api/my-enrollments/');
export const getEnrollmentDetails = (enrollmentId) =>
  apiClient.get(`/api/enrollment/${enrollmentId}/`);
export const updateEnrollment = (enrollmentId, data) =>
  apiClient.patch(`/api/enrollment/${enrollmentId}/`, data);
export const cancelEnrollment = (enrollmentId) =>
  apiClient.post(`/api/enrollment/${enrollmentId}/cancel/`, {});

// ==================== PUBLIC COURSE ENROLLMENT (slug) ====================
export const EnrollToCourse = (slug, enrollmentData) =>
  apiClient.post(`/api/enroll/${slug}/`, enrollmentData);

export const checkEnrollment = (slug) =>
  apiClient.get(`/api/check-enrollment/${slug}/`);

// ==================== USER-SCOPED (dashboard) ====================
export const getMyEnrolledCourses = (params = {}) =>
  apiClient.get('/api/user/enrolled-courses/', { params });

export const getUserEnrolledCourses = (userId) =>
  apiClient.get(`/api/enrollments/user/${userId}/courses/`);

export const getUserNotEnrolledCourses = (userId, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.category_slug) params.append('category_slug', filters.category_slug);
  if (filters.level) params.append('level', filters.level);
  const queryString = params.toString();
  const url = `/api/courses/not-enrolled/user/${userId}/${queryString ? `?${queryString}` : ''}`;
  return apiClient.get(url);
};